module.exports = __webpack_public_path__ + "8997bdb4833ecb939dab66d19f061664.png";